import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * Returns whether the current viewport is below the mobile breakpoint.
 */
export function useIsMobile(): boolean {
    const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

    React.useEffect(() => {
        const mediaQueryList = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

        function handleChange(): void {
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        }

        mediaQueryList.addEventListener('change', handleChange);
        handleChange();

        return () => mediaQueryList.removeEventListener('change', handleChange);
    }, []);

    return Boolean(isMobile);
}
